import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { loadAwards } from '../../redux/awardSlice'
import DsCarousel from "../DsCarousel/DsCarousel"
import { globals } from '../Globals/Globals'
import { loadParams } from '../../redux/paramSlice'

import './HomePlateform.css'

const HomeMonthHotel = (props) => {
    const {awardsItems, loadAwards_result} = useSelector((state) => state.awards)
    const {paramsItems, loadParams_result} = useSelector((state) => state.params)
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true
    
        // ---- Load awards - Hotel du mois
        if (loadAwards_result.status === 'idle'){
            dispatch(loadAwards());
        }
        // Awards loaded - Hotel du mois
        if (loadAwards_result.status === 'succeeded'){
            console.log("loadAwards_result succeeded -> awardsItems:", awardsItems)
        }
    
        // ---- Load params - actu-raw
        if (loadParams_result.status === 'idle'){
            dispatch(loadParams());
        }
        // Awards loaded - Hotel du mois
        if (loadParams_result.status === 'succeeded'){
            console.log("loadParams_result succeeded -> paramsItems:", paramsItems)
        }

        // Cleanup function
        return () => {
            isMounted = false
        }
    }, [loadAwards_result, loadParams_result, dispatch]);

    return(
        <div id="home-month-hotel"
            style={{width:`${paramsItems||"25%"}`}}
            >
            <DsCarousel
                pictures_list =  {awardsItems}
                dom_image_class_containter = {"hotels-image-container"}
                dom_image_prefix = {"hotel-month"}   
                picture_field_name = {"award_hotel_photo"}
                title_field_name = {"award_hotel_name"}
                pause_in_second = {2}
                fallback_picture = {globals.dico.hotels_fallback_picture}
                pause = {globals.parameters.pause_carousel}
            />
        </div>
    )
} 

export default HomeMonthHotel;